import PortfolioApp from "@/_roots/portfolio/PortfolioApp.vue";
import VueInstance from "@/main";
import router from "@/_roots/portfolio/router";

VueInstance(PortfolioApp, router);
